<div class="track-my-location-container">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12">
        <a href="{{locationDetails.tenantInfo.siteName}}" target="_blank">
          <img width="200" src="/assets/images/temp/header_logo.png">
        </a>
      </div>
      <div *ngIf="showTrackMyLocationPage" class="col-6 md:col-12 lg:col-6 sm:col-12 contact-info">
        <div class="col-6 md:col-12 lg:col-6 sm:col-6">
          <strong translate>label_contactNumber</strong>:&nbsp;
          <span>{{locationDetails.tenantInfo.tenantPhoneNum}}</span>
        </div>
        <div class="col-6 md:col-12 lg:col-6 sm:col-6">
          <strong translate>label_supportEmail</strong>:&nbsp;
          <span translate>{{locationDetails.tenantInfo.tenantEmail}}</span>
        </div>
      </div>
    </div>

    <div class="  col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>
    <div>
      <div *ngIf="showTrackMyLocationPage" class="location-info col-12 md:col-12 lg:col-12">

        <div class="col-2 md:col-12 lg:col-2 sm:col-12 content">
          <img class="driver-logo" src="{{imageUrl}}">
        </div>

        <div *ngIf="locationDetails.tourBookingDetailsDto !== undefined && locationDetails.tourBookingDetailsDto !== null">
          <div *ngIf="locationDetails.tourBookingDetailsDto.driverInfo !== undefined && locationDetails.tourBookingDetailsDto.driverInfo !== null"
            class="col-2 md:col-7 lg:col-2 sm:col-6 content">
            <div class="content-header" translate>label_driver</div>
            <div class="content-info">
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.firstName}}
                {{locationDetails.tourBookingDetailsDto.driverInfo.lastName}}</div>
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.numCountryCode}}-{{locationDetails.tourBookingDetailsDto.driverInfo.phoneNum}}</div>
              <p class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.email}}</p>
              <div class="star">
                <span *ngFor="let star of maxRating;let idx = index">
                  <i *ngIf="idx < locationDetails.tourBookingDetailsDto.driverInfo.driverRating" class="fa fa-star active"></i>
                  <i *ngIf="idx >= locationDetails.tourBookingDetailsDto.driverInfo.driverRating" class="fa fa-star"></i>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="locationDetails.tourBookingDetailsDto.passengerInfo !== undefined && locationDetails.tourBookingDetailsDto.passengerInfo !== null"
            class="col-2 md:col-5 lg:col-2 sm:col-6 content">
            <div class="content-header" translate>label_passenger</div>
            <div class="content-info">
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.firstName}}
                {{locationDetails.tourBookingDetailsDto.passengerInfo.lastName}}</div>
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.numCountryCode}}-{{locationDetails.tourBookingDetailsDto.passengerInfo.phoneNum}}</div>
              <p class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.email}}</p>
            </div>
          </div>
          <div *ngIf="locationDetails.tourBookingDetailsDto.vehicleInfo!== undefined && locationDetails.tourBookingDetailsDto.vehicleInfo !== null"
            class="col-3 md:col-12 lg:col-3 sm:col-12 content" style="margin-bottom: 11px;">
            <div class="content-header" translate>label_car_details</div>
            <div class="content-info">
              <table>
                <tbody>
                  <tr>
                    <td translate>label_car_type_with_colon </td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleType}} </td>
                  </tr>
                  <tr>
                    <td translate>label_model_with_colon</td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.makeModel}}</td>
                  </tr>
                  <tr>
                    <td translate>label_vehicle_type_with_colon</td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleType}} </td>
                  </tr>
                  <tr>
                    <td translate>label_plate_number_with_colon </td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleNumber}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div *ngIf="locationDetails.tourBookingDetailsDto.tourBookingInfo !== undefined && locationDetails.tourBookingDetailsDto.tourBookingInfo !== null"
            class="col-3 md:col-12 lg:col-3 sm:col-12 content">
            <div class="content-header" translate>label_trip_details</div>
            <div class="content-info">
              <p>
                <i class="fa fa-circle start" style="margin-right: 5px;"></i>{{locationDetails.tourBookingDetailsDto.tourBookingInfo.pickupLocationName}}</p>
              <p>
                <i class="fa fa-circle end" style="margin-right: 5px;"></i>{{locationDetails.tourBookingDetailsDto.tourBookingInfo.dropLocationName}}</p>
              <div>
                <span translate>label_status_with_colon</span>
                <span class="data-info" style="font-weight: bold;color:green;">{{tourStatus}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div class="col-12 md:col-12 lg:col-12 sm:col-12 map-container">
        <div id="trackLocationMap" class="map"></div>
      </div>

    </div>

    <div class="col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12" style="text-align: center;">
        <p>
          We offer Android and iOS Application
          <br> to book taxi at your doorsteps.
        </p>
        <p>
          It is easy to use and book as your requirement
        </p>
      </div>
      <div class="col-6 md:col-12 lg:col-6 sm:col-12">
        <div class="col-1 md:col-1 lg:col-1"></div>
        <div class="col-5 md:col-5 lg:col-5 sm:col-12">
          <a href="{{locationDetails.tenantInfo.appStoreUrl}}" target="_blank">
            <img src="/assets/images/temp/app_store.png">
          </a>
        </div>

        <div class="col-5 md:col-5 lg:col-5 sm:col-12">
          <a href="{{locationDetails.tenantInfo.playStoreUrl}}" target="_blank">
            <img src="/assets/images/temp/play_store.png">
          </a>
        </div>
        <div class="col-1 md:col-1 lg:col-1 sm:col-12"></div>
      </div>
    </div>

    <div class="  col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class="  col-12 md:col-12 lg:col-12 sm:col-12">
      <!-- <div class="col-6 md:col-12 lg:col-6 sm:col-12" style="text-align: center;margin-top: 17px;">
        &#9400; Copyright 2019 by Mobisoft. All Rights Reserved.
      </div> -->
      <div class="col-6 md:col-12 lg:col-6 sm:col-12" style="text-align: center;">
        <div class="col-4 md:col-4 lg:col-4 sm:col-12"></div>
        <div class="col-1 md:col-1 lg:col-1 sm:col-2">
          <a href="{{locationDetails.tenantInfo.facebookUrl}}" target="_blank">
            <img src="/assets/images/temp/footer_fb_icon.png">
          </a>
        </div>

        <div class="col-1 md:col-1 lg:col-1 sm:col-2">
          <a href="{{locationDetails.tenantInfo.twitterUrl}}" target="_blank">
            <img src="/assets/images/temp/footer_twitter_icon.png">
          </a>
        </div>

        <div class="col-5 md:col-5 lg:col-5 sm:col-12"></div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="!showTrackMyLocationPage" style="position: absolute; top: 50%; left: 30%;text-align: center; font-size: 16px;">
  {{errorMessage}}
</div>